// @ts-check
import React from 'react';

import Collapse from '@liquidweb-dev/undercurrent/Collapse';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import { ReactComponent as LogoText } from 'images/lw-text-logo.svg';
import AlertMenu from '../common/AlertMenu';
import MobileMenuButton from '../common/MobileMenuButton';
import TopNavSearch from '../common/SearchButton';
import SupportMenu from '../common/SupportMenu';
import UserMenu from '../common/UserMenu';
import useLeftHandLayout from '../context';
import BasketAdmin from '../LargeNav/contents/BasketAdmin';
import LogoutOnly from '../LargeNav/contents/LogoutOnly';
import OrderConfirmation from '../LargeNav/contents/OrderConfirmation';
import Suspended from '../LargeNav/contents/Suspended';
import Unauthed from '../LargeNav/contents/Unauthed';
import VerificationRequired from '../LargeNav/contents/VerificationRequired';
import { useNavTopInnerX, useNavTopOuterY, useNavTopSize } from '../navSetter';
import SmallNavDrawer from './NavDrawer';

const SmallNavContent = () => {
	const { roles, mobileOpen, path } = useLeftHandLayout();

	if (!roles.loggedIn) {
		return <Unauthed />;
	}

	if (roles.loggedIn && roles.basketAdmin) {
		return (
			<BasketAdmin
				logoutButtonProps={{
					sx: {
						backgroundColor: ({ palette }) => palette.uc.bg.weak,
						'&:hover': {
							backgroundColor: ({ palette }) => palette.uc.bg.weak,
						},
					},
				}}
			/>
		);
	}

	if (roles.loggedIn && !roles.accountLogin) {
		return (
			<LogoutOnly
				logoutButtonProps={{
					sx: {
						backgroundColor: ({ palette }) => palette.uc.bg.weak,
						'&:hover': {
							backgroundColor: ({ palette }) => palette.uc.bg.weak,
						},
					},
				}}
			/>
		);
	}

	if (roles.suspended) {
		return <Suspended />;
	}

	if (roles.verificationRequired) {
		return (
			<VerificationRequired
				logoutButtonProps={{
					sx: {
						backgroundColor: ({ palette }) => palette.uc.bg.weak,
						'&:hover': {
							backgroundColor: ({ palette }) => palette.uc.bg.weak,
						},
					},
				}}
			/>
		);
	}

	if (path === '/shop/complete') {
		return (
			<OrderConfirmation
				logoutButtonProps={{
					sx: {
						backgroundColor: ({ palette }) => palette.uc.bg.weak,
						'&:hover': {
							backgroundColor: ({ palette }) => palette.uc.bg.weak,
						},
					},
				}}
			/>
		);
	}

	return (
		<>
			<MobileMenuButton />

			<Stack flex="0% 1 1" overflow="auto" direction="row">
				<LogoText />
			</Stack>

			<Collapse in={mobileOpen} orientation="horizontal">
				<Stack direction="row" useFlexGap gap={100}>
					<SupportMenu />
					<UserMenu />
				</Stack>
			</Collapse>
			<Collapse in={!mobileOpen} orientation="horizontal">
				<Stack direction="row" useFlexGap gap={100}>
					<AlertMenu />
					<TopNavSearch />
				</Stack>
			</Collapse>

			<SmallNavDrawer />
		</>
	);
};

const TOPNAV_SIZE_PX = 60;
const TOPNAV_INNER_X_PX = 24;
const TOPNAV_OUTER_Y_PX = 0;

export function SmallNav() {
	useNavTopSize(TOPNAV_SIZE_PX);
	useNavTopInnerX(TOPNAV_INNER_X_PX);
	useNavTopOuterY(TOPNAV_OUTER_Y_PX);

	return (
		<>
			<Stack
				component="nav"
				position="fixed"
				top={0}
				left={0}
				right={0}
				height={TOPNAV_SIZE_PX}
				overflow="hidden"
				direction="row"
				alignItems="center"
				paddingY={100}
				paddingX={`${TOPNAV_INNER_X_PX}px`}
				zIndex={(theme) => theme.zIndex.appBar}
				bgcolor={(theme) => theme.palette.uc.bg.weak}
				useFlexGap
				gap={100}
			>
				<SmallNavContent />
			</Stack>
		</>
	);
}

export default SmallNav;
